module.exports = __webpack_public_path__ + "static/media/settings.dc68a1ff.svg";